import { combineReducers } from 'redux'
import dataReducer from 'lib/reducers/dataReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import { profileTypes } from 'actions/types'

const initialState = null
const baseType = profileTypes.FETCH_PERSON_PROFILE

const reducer = combineReducers({
  requestState: requestStateReducer(baseType),
  data: dataReducer({ initialState, baseType }),
})

export default reducer
